const validDomains = [
  "techtribe.nl",
  "touchtribe.nl",
  "webflight.nl",
  "resoluut.com",
  "sodastudio.nl",
  "mrkoreander.nl",
  "milkshake.nl",
  "milkshake-research.nl",
  "bigshots.nl",
  "elevator.amsterdam",
  "unplugged.amsterdam",
  "makerlab.nl",
  "saxum.nl",
  "godo.nl",
  "noun.nl",
  "elements.nl",
  "alwaysbelearning.nl",
  "elementsinteractive.es",
  "deduction.nl",
  "stutit.nl",
  "saxuminfra.nl",
  "makerstreet.nl",
];

const availableCoinNames = [
  "$oda",
  "abl",
  "bigshots",
  "deduction",
  "duppie",
  "elements",
  "elevator",
  "godo",
  "korrency",
  "makerlab",
  "milkshekel",
  "noun",
  "resoluta",
  "stuit",
  "sxm",
  "tech",
  "touch",
  "webmiles",
  "sxminfra",
  "stutit",
  "saxuminfra",
  "webflight",
];

const availableAssetIds = [
  "95vgwmc2JrqSCeNnWKU3CQoRbrnCKKM6v3ztzJz6gNNr",
  "4GwbjR7ehtdSZszaQwKwbSLhf1Y2zopaAvZRQppR1Rjs",
  "6QurSAdo81YXWuV5dkvqVrnUeDvGUdsHB2ekabxtDbRr",
  "7DC6REYSn718EXDYqgPEaCG1DPFGgoejKPeE9DVbJhYV",
  "EjWiVXQW1pCECLffZLMk8MDK2P93X9KMdQPZY3rJv37a",
  "DEoVtmxntYvaUa6QBJzdSxtb9Z7RJnMmdh6oL2Q8aLzS",
  "6AhrsUPZJusV5ZC3jusSJPJsAojGv7RehEHuwrsjRm2i",
  "F5Rmn3niT5NUq4UrMo,Z74Se5MEjqyYjyo8Aq4ohdYUk4",
  "845nsbkJE2TtP4L3q6JLGkAjGhkN1SpHoCEgQLE82k9R",
  "3fCk4sJbnZPFgTRtntyDACfdMHQoBEmsBQykKnZtNn8F",
  "3fCk4sJbnZPFgTRtntyDACfdMHQoBEmsBQykKnZtNn8F",
  "2VEZ64RkMVLN8Gyi8Q5pdHKEBay1RoBg2TN9e9UWiHwP",
  "5nr5jNCYf7Xo8hek6akhtaDgAS3ow7KvVTa4Y6Zu63p8",
  "2dwR2LmCAGuP9aH5kmzQii2Pf2az9eHyJL1WUjPDXRju",
  "FnK2YVc1p3Gczjjdz6KWf1BLFrXUn82Cm6Q1Qdzyenn2",
  "uYJdD1are2r9fscjTok5SwuHywe2DaTUiLytTfMTxn6",
  "37ZVm3pHJNureq7Gc8QYBEdYY24GikNFSNpzefu3ufN9",
  "4GhL2WTa338bCKBHhu31EYudWLYJ1hHudpVdgxM1pqUi",
  "F5Rmn3niT5NUq4UrMoZ74Se5MEjqyYjyo8Aq4ohdYUk4",
  "63oRAFy4z2M1GdotS9VRKs5hs1JFccg5Sohb12MRbCX",
  "F2LAq3n4vYggcMMGg9dPghDCk8wqoThAYYqKR6gvgZ2R",
];

export { validDomains, availableCoinNames, availableAssetIds };
